export function getCoordinatesSvgPoint(
  svg: SVGSVGElement,
  clientX: number,
  clientY: number,
): {x: number; y: number} {
  const pt = svg?.createSVGPoint();
  pt.x = clientX;
  pt.y = clientY;
  const coords = pt.matrixTransform(svg.getScreenCTM()?.inverse());
  return {x: coords.x, y: coords.y};
}

export function parseXmlToSvg(strXml: string): Document {
  const domParser = new DOMParser();
  return domParser.parseFromString(strXml, 'image/svg+xml');
}
